import React from 'react';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import { useHistory } from 'react-router-dom';
import Store from 'store/store';
import Routes from 'consts/routes';
import Router from 'components/Router/Router';

const { useRouteMatch, useParams } = Router;
const { connect, selectors } = Store;

interface Props {
  caseCustomer?: any;
  caseInfo?: any;
  classes: any;
}

const CaseSubHeader = ({ caseCustomer, caseInfo, classes }: Props) => {
  const history = useHistory();
  const route = useRouteMatch();
  const { portfolio } = useParams() as any;

  const innerRoutes = [
    {
      route: Routes.QUESTIONNAIRE.MAIN,
      text: 'ATR Questionnaire',
      backRoute: Routes.RISK_SUMMARY.MAIN.replace(':portfolio', portfolio)
    },
    {
      route: Routes.CFL_QUESTIONNAIRE,
      text: 'CFL Questionnaire',
      backRoute: Routes.RISK_SUMMARY.MAIN.replace(':portfolio', portfolio)
    },
    {
      route: Routes.EXP_QUESTIONNAIRE,
      text: 'Experience Questionnaire',
      backRoute: Routes.RISK_SUMMARY.MAIN.replace(':portfolio', portfolio)
    },
    {
      route: Routes.RECOMMENDATIONS.PORTFOLIO_BUILDER,
      text: 'Portfolio Builder',
      backRoute: Routes.RECOMMENDATIONS.MAIN.replace(':portfolio', portfolio)
    }
  ];

  const currentInnerRoute = route
    ? innerRoutes.find(innerRoute => innerRoute.route === route.path)
    : null;

  return (
    <>
      <span className={classes.link} onClick={() => history.push(Routes.CASES)}>
        Cases
      </span>
      <ChevronRightRoundedIcon fontSize="small" />
      <span
        className={currentInnerRoute ? classes.link : ''}
        onClick={() =>
          currentInnerRoute && history.push(currentInnerRoute.backRoute)
        }
      >
        {caseInfo.name} | {caseCustomer.display_name}
      </span>
      {currentInnerRoute && (
        <>
          <ChevronRightRoundedIcon fontSize="small" />
          <span>{currentInnerRoute.text}</span>
        </>
      )}
    </>
  );
};

export default connect(
  (state: any) => ({
    caseCustomer: selectors.caseSelectors.caseCustomer(state),
    caseInfo: selectors.caseSelectors.case(state)
  }),
  null
)(CaseSubHeader);
